<template>
  <div>
    <div>
      <b-embed 
        type="iframe"
        aspect="4by3"
        src="https://www.guestia.com/"
        allowfullscreen
      ></b-embed>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style>
</style>